import { createSelector } from 'reselect';

export const plaidSelector = (state) => state.plaid;

export const selectLinkToken = createSelector(
  plaidSelector,
  (state) => state?.linkToken,
);
